import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'static-ftr',
  templateUrl: './layout-ftr.component.html',
  styleUrls: ['./layout-ftr.component.scss']
})
export class LayoutFtrComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
